import {
  BlogActionsWrapper,
  BlogCardAvatar,
  BlogCardBottomContentWrapper,
  BlogCardImage,
  BlogCardLink,
  BlogCardOptionsProvider,
  BlogCardTitle,
  BlogCardWrapper,
  BlogChips,
  BlogChipsWrapper,
  BlogOptions,
  BlogShare,
} from "../blogCard";
import { BlogCardBottomWrapper } from "../blogCard/BlogCardBottomWrapper";
import { BlogCardUsername } from "../blogCard/BlogCardUsername";
import { BlogCardBottomDate } from "../blogCard/BlogCardBottomDate";
import { Listing } from "../../../interfaces/training-plan/Listing";

type BlogPageCardProps = { blog: Listing };

export const BlogPageCard = ({ blog }: BlogPageCardProps) => {
  return (
    <BlogCardLink blog={blog}>
      <BlogCardWrapper>
        <BlogCardImage title={`${blog.title} | Blog`} image={blog.coverImage} />
        <BlogCardTitle>{blog.title}</BlogCardTitle>
        <BlogChipsWrapper>
          <BlogChips objectives={blog.objectives} />
        </BlogChipsWrapper>
        <BlogCardBottomWrapper>
          <BlogCardAvatar src={blog.user.avatarUrl} name={blog.user.name} />

          <BlogCardBottomContentWrapper>
            <BlogCardUsername>{blog.user.name}</BlogCardUsername>
            <BlogCardBottomDate date={blog.updated_at ?? blog.created_at} />
          </BlogCardBottomContentWrapper>

          <BlogActionsWrapper>
            <BlogShare blog={blog} />
            <BlogCardOptionsProvider>
              <BlogOptions coach={blog.user} />
            </BlogCardOptionsProvider>
          </BlogActionsWrapper>
        </BlogCardBottomWrapper>
      </BlogCardWrapper>
    </BlogCardLink>
  );
};
